import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'
import OrganizationListing from './OrganizationListing'
import OrganizationForm from './OrganizationForm'

const OrganizationsRoutes = () => {
  const { path } = useRouteMatch()
  return (
    <Switch>
      <Route exact path={path}>
        <OrganizationListing />
      </Route>
      <Route path={`${path}/new`}>
        <OrganizationForm displayContext="page" />
      </Route>
      <Route path={`${path}/edit/:organizationId`}>
        <OrganizationForm displayContext="page" />
      </Route>
    </Switch>
  )
}

export default OrganizationsRoutes
